import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

import css from "./CycleDayPacksSingleComponent.module.css";
import { cycleDayMenuActions } from "../../../store/slices/menu-slices";
import { SingleMenuDishComponent } from "../SingleMenuDishComponent/SingleMenuDishComponent";
import NutrientSummary from "../NutrientSummary/NutrientSummary";

const CycleDayPacksSingleComponent = ({ pack, cycleDay, setIsModalOpen }) => {
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);

    const { id, name, meals, menuDishes, pricePerDay } = pack;
    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name["en"];

    const openModal = (mealId, packId, idMatching) => {
        dispatch(cycleDayMenuActions.setActivePackId(packId));
        dispatch(cycleDayMenuActions.setActiveMealId(mealId));
        dispatch(cycleDayMenuActions.setActiveIdMatching(idMatching || null));
        setIsModalOpen(true);
    };

    return (
        <div className={css.wrap}>
            <div className={css.header} onClick={() => setIsDetailsOpen(!isDetailsOpen)}>
                <div className={css.packName}>{displayName}</div>
                <NutrientSummary menuDishes={menuDishes} />

                <div className={css.packPriceContainer}>
                    {menuDishes.length > 0 && (
                        <>
                            <div className={css.packPrice}>
                                <span className={css.packPriceLabel}>Price per day:</span>
                                <span className={css.packPriceValue}>{Number(pricePerDay).toFixed(2)}</span>
                            </div>
                            <div className={css.packCoast}>
                                <span className={css.packCoastText}>
                                    Cost (Total{" "}
                                    {menuDishes
                                        .reduce(
                                            (acc, d) =>
                                                acc +
                                                Number(d.dish?.cost || 0) +
                                                Number(d.proteinDish?.cost || 0) +
                                                Number(d.sauceDish?.cost || 0),
                                            0
                                        )
                                        .toFixed(2)}
                                    )
                                </span>
                            </div>
                        </>
                    )}
                    <ChevronDown
                        className={css.chevron}
                        aria-hidden
                        style={{ transform: isDetailsOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                    />
                </div>
            </div>

            {isDetailsOpen && (
                <>
                    {(meals || []).map((meal) => {
                        const dish = menuDishes.find((d) => d.mealId === meal.id);
                        const mealName = meal.name[currentLanguage] || meal.name["en"];

                        if (!dish) {
                            return (
                                <div className={css.container} key={meal.id}>
                                    <div className={css.info}>
                                        <div
                                            className={css.noData}
                                            onClick={() => openModal(meal.id, id, null)}
                                        >
                                            {mealName}: No data
                                        </div>
                                    </div>
                                </div>
                            );
                        }

                        return (
                            <div className={css.container} key={dish.id}>
                                <div className={css.info}>
                                    <SingleMenuDishComponent
                                        dish={dish.dish}
                                        menuId={dish.id}
                                        type={dish.type}
                                        proteinDish={dish.proteinDish}
                                        sauceDish={dish.sauceDish}
                                        mealName={mealName}
                                        setIsOpen={setIsModalOpen}
                                        idMatching={dish.id}
                                        mealId={dish.mealId}
                                        packId={id}
                                        isCycleMode={true}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
};

export default React.memo(CycleDayPacksSingleComponent);
